<template>
  <div class="account-settings-info-view">
    <a-row :gutter="16">
      <a-col :md="24" :lg="16">
        <ak-inputs ref="inputs" :options="options" v-model="data" />
        <a-form-item>
          <a-button type="primary" @click="save">保存</a-button>
        </a-form-item>
      </a-col>
      <a-col :md="24" :lg="8" :style="{ minHeight: '180px' }">
        <ak-input-image round class="ant-upload-preview" v-model="avatar" />
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  data () {
    return {
      avatar: '',
      options: [{
        name: 'name',
        note: '姓名',
        type: 'String',
        disabled: true
      }, {
        name: 'username',
        note: '手机账户',
        type: 'String',
        disabled: true,
        validators: [
          (val) => val ? null : '手机账户不可为空',
          (val) => {
            if (!(/^1[3456789]\d{9}$/.test(val))) {
              return '请输入正确的手机号码'
            }
          }
        ]
      }],
      data: {}
    }
  },
  computed: {
    ...mapState([
      'user'
    ])
  },
  mounted () {
    if (this.user.avatar) {
      this.avatar = this.user.avatar
    }
    this.data = this.user
  },
  methods: {
    async save () {
      let inputsData = this.data
      let data = { ...inputsData, avatar: this.avatar }
      if (data.__type) { delete data.__type }
      if (data.className) { delete data.className }
      if (data.sessionToken) { delete data.sessionToken }
      let erros = await this.$refs.inputs.validate()
      if (Object.keys(erros).length) {
        return this.$notification['error']({
          message: '您输入有误',
          description: '无法保存数据'
        })
      }
      this.$tkParse.put(`/classes/_User/${this.user.objectId}`, data).catch((e) => {
        this.$notification['error']({
          message: '网络错误',
          description: '无法保存数据'
        })
        throw e
      })
      this.$notification['success']({
        message: '保存成功',
        description: '用户信息已更新'
      })
      this.$store.commit('setUser', { ...this.user, ...data })
    }
  }
}
</script>

<style lang="scss" scoped>

  .avatar-upload-wrapper {
    height: 200px;
    width: 100%;
  }

  .ant-upload-preview {
    position: relative;
    margin: 0 auto;
    width: 100%;
    max-width: 180px;
    .mask {
      opacity: 0;
      position: absolute;
      cursor: pointer;
      transition: opacity 0.4s;

      &:hover {
        opacity: 1;
      }

      i {
        font-size: 2rem;
        position: absolute;
        top: 50%;
        left: 50%;
        margin-left: -1rem;
        margin-top: -1rem;
        color: #d6d6d6;
      }
    }

    img, .mask {
      width: 100%;
      max-width: 180px;
      height: 100%;
      border-radius: 50%;
      overflow: hidden;
    }
  }
</style>
